import React, { useContext } from "react"
import PropTypes from "prop-types"
import PageHeader from "../../PageHeader"
import useLabels from "../../../hooks/useLabels"
import { UserContext } from "../../../context/userContext"

function ListHeader({ idTemplate }) {
  const [loadingLabels, labels] = useLabels([idTemplate])
  const userCtx = useContext(UserContext)
  const isInactiveStatus = [
    "Inactive Discharged",
    "Inactive Referrals",
  ].includes(userCtx.participant_membership_status)

  if (loadingLabels) return <p>Loading...</p>

  const actions = !isInactiveStatus
    ? [
        {
          to: `/form/${idTemplate}/1`,
          label: `New ${labels[idTemplate]}`,
        },
      ]
    : []

  return (
    <div>
      <PageHeader title={labels[idTemplate]} actions={actions} />
    </div>
  )
}

ListHeader.propTypes = {
  idTemplate: PropTypes.string.isRequired,
}

export default ListHeader
